'use client';

import { usePathname } from 'next/navigation';
import { stripLangPrefix } from '@/i18n/locale';
import { useLanguage } from '@/stores/languageStore';
import { findRouteSeo } from './routeSeo';

export function RouteHeading() {
  const pathname = usePathname();
  const language = useLanguage();
  const seo = findRouteSeo(stripLangPrefix(pathname));
  if (!seo) return null;
  return <h1 className="sr-only">{seo[language].h1}</h1>;
}
